"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plugin = exports.Touch = exports.Pc = exports.PluginIcon = exports.TouchIcon = exports.PcIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Pc = require("./pc");
exports.Pc = Pc;
const Plugin = require("./plugin");
exports.Plugin = Plugin;
const Touch = require("./touch");
exports.Touch = Touch;
exports.PcIcon = (0, react_1.forwardRef)((_a, ref) => {
    var { name } = _a, props = __rest(_a, ["name"]);
    const Icon = Pc[name];
    return (0, jsx_runtime_1.jsx)(Icon, Object.assign({ ref: ref }, props));
});
exports.TouchIcon = (0, react_1.forwardRef)((_a, ref) => {
    var { name } = _a, props = __rest(_a, ["name"]);
    const Icon = Touch[name];
    return (0, jsx_runtime_1.jsx)(Icon, Object.assign({ ref: ref }, props));
});
exports.PluginIcon = (0, react_1.forwardRef)((_a, ref) => {
    var { name } = _a, props = __rest(_a, ["name"]);
    const Icon = Plugin[name];
    return (0, jsx_runtime_1.jsx)(Icon, Object.assign({ ref: ref }, props));
});
